import styled from 'styled-components'

const iconSizeSmall = '50px'
const iconSize = '60px'
const titleMarginSmall = '15px'
const titleMargin = '20px'

export const PresentationIndicatorsComponent = styled.div`
  overflow-y: auto;

  .overlay-bg-click-area {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .container-fluid {
    // set fullscreen only for viewport sm or smaller
    @media ${ (props) => props.theme.breakpoints.devices.max.sm } {
      padding: 0;
    }
  }

  .overlay-container {
    position: relative;
    background-color: ${ (props) => props.theme.colors.weiss };
    overflow: hidden;
    min-height: 100vh;

    @media ${ (props) => props.theme.breakpoints.devices.min.sm } {
      margin: 100px 0;
      min-height: auto;
    }
  }

  .overlay-header {
    display: flex;
    min-height: ${ iconSizeSmall };
    align-items: flex-start;

    @media ${ (props) => props.theme.breakpoints.devices.min.sm } {
      min-height: ${ iconSize };
      box-shadow: 0 2px 1px 0 ${ (props) => props.theme.colors.boxShadow };
    }
  }

  .overlay-close {
    display: inline-block;
    font-size: 18px;
    cursor: pointer;
    margin-right: 30px;
    color: ${ (props) => props.theme.colors['icon-grau2'] };
    margin-top: ${ titleMarginSmall };

    @media ${ (props) => props.theme.breakpoints.devices.min.sm } {
      margin-top: ${ titleMargin };
      font-size: 24px;
    }
  }

  .overlay-icon {
    display: inline-flex;
    width: ${ iconSizeSmall };
    height: ${ iconSizeSmall };
    font-size: 38px;
    justify-content: center;
    align-items: center;
    color: ${ (props) => props.theme.colors.weiss };
    background-color: ${ (props) => props.theme.colors['aok-gruen'] };

    @media ${ (props) => props.theme.breakpoints.devices.min.sm } {
      width: ${ iconSize };
      height: ${ iconSize };
    }
  }

  .overlay-title {
    margin: 0 20px;
    flex-grow: 1;
    margin-top: ${ titleMarginSmall };

    @media ${ (props) => props.theme.breakpoints.devices.min.sm } {
      margin-top: ${ titleMargin };
    }
  }

  .overlay-content {
    padding: 30px;
  }

  :first-child .indicator-list-title {
    margin-top: 0px;
  }

  .indicator-list-title {
    font-weight: bold;
    margin: 18px 0px 18px;

    > * {
      margin-left: 8px;
    }

    > .indicator-list-title-tooltip {
      font-weight: 200;
    }
  }

  .indicator-group + :not(.indicator-group) {
    margin-top: 18px;
  }

  .indicator-group-label {
    margin-top: 18px;
    line-height: 1.39;
    font-size: 18px;

    > * {
      margin-left: 8px;
    }
  }

  .indicator-group-options {
    padding-left: 25px;
  }
`

export const CloseOverlayRow = styled.div`
  margin-top: 24px;
  display: flex;
  justify-content: flex-end;
`
